import styles from './style.module.css';

const Content = () => {
  return (
    <div className={styles.test0}>
      <h1 className={styles.test1}>Tobias er kul</h1>
      <div className={styles.test2}>Han er aldri sen til webkom møte</div>
    </div>
  );
};

export default Content;
